<template>
  <v-container tag="section">
    <v-toolbar flat transparent>
      <v-toolbar-title>{{ this.title }}</v-toolbar-title>

      <div class="flex-grow-1"></div>

      <template>
        <v-btn color="primary" v-if="hasPermission" :name="addResourceName" @click="addResource">
          <v-icon>mdi-plus-circle</v-icon> &nbsp; Add
          <span class="resource-name">{{ this.resourceName | startCase }}</span>
        </v-btn>
      </template>
    </v-toolbar>
  </v-container>
</template>

<script>
import _ from 'lodash';
import canDo from '@/utils/permissions';

export default {
  computed: {
    title() {
      return _.startCase(`${this.resourceName}s`);
    },
    hasPermission() {
      return canDo(this.resourceName, 'create');
    },
    siteId() {
      return this.$route.params.site_id;
    },
    destination() {
      if (this.siteId) {
        return `/sites/${this.siteId}/${this.urlFragment}/create`;
      } else {
        return `/admin/${this.urlFragment}/create`;
      }
    },
    addResourceName() {
      return `add${this.resourceName}`;
    },
  },
  methods: {
    addResource() {
      this.$router.push(this.destination);
    },
  },
};
</script>

<style lang="scss">
#core-app-bar {
  width: auto;
  a {
    text-decoration: none;
  }
  button {
    margin-left: 1em;
  }
}

header {
  margin-bottom: 3em;
}

.resource-name {
  display: none;
  @media (min-width: 600px) {
    display: block;
  }
}
</style>
